import React from 'react';

import './spinner.scss';

export const ContentSpinner: React.FC = () => {
  return (
    <div className="spinner-container">
      <div className="content-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export const Spinner = () => {
  return (
    <div className="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export const SpinnerForTable: React.FC = () => {
  return (
    <div className="spinner-contaier-for-table">
      <div className="content-spinner-for-table">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export const SpinnerForm: React.FC = () => {
  return (
    <div className="spinner-form">
      <div className="spinner-addtolist">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};